export default __webpack_public_path__ + "static/3-6e700d9ddb6f6accbe7187a598507aa8.webp";